import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

// Bulk merge using selected record IDs from a table
export default function(tableId) {

  // Merge bulk
  $('#mergeBulk').off().on('click', function() {
    let url = $(this).data('url');
    let params = {};

    // Set checked checkboxes
    let recordIds = []
    $('#' + tableId + ' tbody tr .checkbox').each(function() {
      let checked = this.checked;
      if (checked) {
        let recordId = $(this).closest('tr').attr('data-record-id');
        recordIds.push(recordId);
      }
    });
    params['record_ids'] = recordIds;

    // Update and reload
    $.ajax({
      type: 'POST',
      dataType: 'application/json',
      url: url + '?' + $.param(params),
      complete(result) { 
        $('#' + tableId).DataTable().ajax.reload();
      }
    });
  })

}